<!--
 * @Descripttion:确认订单页面组件 
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-10-28 12:20:28
--> 

<template>
  <div class="confirmOrder">
    <!-- 头部 -->
    <div class="top-header">
      <div class="cart-header">
        <div class="logo">
          <router-link to="/">
            <img src="../assets/imgs/clogo.png" alt />
          </router-link>
        </div>
        <div class="cart-header-content">
          <p>Confirm Order</p>
        </div>
        <div class="cart-header-right">
          <div class="cart-header-select">
            <el-dropdown>
              <router-link to class="href">
                <span style="margin-right:5px">{{this.$store.getters.getUser.nickname}}</span>
                <i class="el-icon-caret-bottom"></i>
              </router-link>
              <el-dropdown-menu slot="dropdown">
                <router-link to="/">
                  <el-dropdown-item class="dropdown-menu">Home</el-dropdown-item>
                </router-link>
                <router-link to="/center">
                  <el-dropdown-item class="dropdown-menu">Personal Center</el-dropdown-item>
                </router-link>
                <router-link to="/">
                  <el-dropdown-item class="dropdown-menu">Evaluate and share the list</el-dropdown-item>
                </router-link>
                <router-link to="/favorite">
                  <el-dropdown-item class="dropdown-menu">My Collection</el-dropdown-item>
                </router-link>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="cart-header-order">
            <span>|</span>
            <router-link to="/order" class="href">My Order</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 头部END -->

    <!-- 主要内容容器 -->
    <div class="confirm-content">
      <!-- 选择地址 -->
      <div class="section-address">
        <p class="title">Receiving address</p>
        <div class="address-body">
          <ul>
            <router-link to>
              <li
                :class="item.id == confirmAddress ? 'in-section' : ''"
                v-for="item in address"
                :key="item.id"
                @click="selectAddress(item)"
              >
                <h2>{{item.name}}</h2>
                <p class="phone">{{item.phone}}</p>
                <p class="address">{{item.address}}</p>
              </li>
            </router-link>
            <li class="add-address" @click="addVisible=true">
              <i class="el-icon-circle-plus-outline"></i>
              <p>Add</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 选择地址END -->

      <!-- 商品及优惠券 -->
      <div class="section-goods">
        <h3 class="title">Products</h3>
        <div class="goods-list">
          <ul>
            <li v-for="item in getCheckGoods" :key="item.id">
              <img :src="item.img_path" />
              <span class="pro-name">{{item.name}}</span>
              <span class="pro-price">{{item.discount_price}}₹</span>
              <span class="pro-num">x {{item.num}}</span>
              <span class="pro-status"></span>
              <span class="pro-total">{{item.discount_price * item.num}}₹</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 商品及优惠券END -->

      <!-- 付款方式 -->
      <div class="section-shipment">
        <p class="title">Payment Method</p>
        <div class="shipment">
          <el-radio v-model="paymentMethod" label="cod">Cash on Delivery</el-radio>
          <el-radio v-model="paymentMethod" label="upi">UPI Pay</el-radio>
        </div>
      </div>
      <!-- 付款方式END -->

      <!-- 配送方式 -->
      <div class="section-shipment">
        <p class="title">Delivery Method</p>
        <div class="shipment">
          <el-radio v-model="deliveryMethod" label="flat">Free Shipping</el-radio>
        </div>
      </div>
      <!-- 配送方式END -->

      <!-- 发票 -->
      <div class="section-invoice">
        <p class="title">Invoice</p>
        <p class="invoice">Electronic Invoice</p>
        <p class="invoice">Personal</p>
        <p class="invoice">Inventory</p>
      </div>
      <!-- 发票END -->

      <!-- 结算列表 -->
      <div class="section-count">
        <div class="money-box">
          <ul>
            <li>
              <span class="title">Number of products：</span>
              <span class="value">{{getCheckNum}}</span>
            </li>
            <li>
              <span class="title">Total product price：</span>
              <span class="value">{{getTotalPrice}}₹</span>
            </li>
            <li>
              <span class="title">Promotional Offer：</span>
              <span class="value">-0₹</span>
            </li>
            <li>
              <span class="title">Coupon deduction：</span>
              <span class="value">-0₹</span>
            </li>
            <li>
              <span class="title">Shipping Cost：</span>
              <span class="value">0₹</span>
            </li>
            <li class="total">
              <span class="title">Total payable amount：</span>
              <span class="value">
                <span class="total-price">{{getTotalPrice}}</span>₹
              </span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 结算列表END -->

      <!-- 结算导航 -->
      <div class="section-bar">
        <div class="btn">
          <router-link to="/cart" class="btn-base btn-return">Return to Cart</router-link>
          <a href="javascript:void(0);" @click="addOrder" class="btn-base btn-primary">Check Out</a>
        </div>
      </div>
      <!-- 结算导航END -->
    </div>
    <!-- 主要内容容器END -->
    <!-- 新建收货地址弹出框 -->
    <el-dialog
      title="Create a new shipping address"
      :visible.sync="addVisible"
      :width="isMobile ? '92%' : '30%'"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        :label-position="isMobile ? 'top' : 'right'"
        :label-width="isMobile ? 'auto' : '70px'"
      >
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="Phone Number" prop="phone">
          <el-input v-model="form.phone" clearable></el-input>
        </el-form-item>
        <el-form-item label="Detailed Address" prop="address">
          <el-input type="textarea" rows="5" v-model="form.address"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="postEdit">Confirm</el-button>
        <el-button @click="addVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
    <!-- 新建收货地址弹出框END -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import * as addressesAPI from '@/api/addresses'
import * as ordersAPI from '@/api/orders'
import * as cartsAPI from '@/api/carts'
export default {
  name: '',
  data() {
    return {
      // 选择的地址id
      confirmAddress: 0,
      // 地址列表
      address: [],
      addVisible: false,
      paymentMethod: 'cod',
      deliveryMethod: 'flat',
      isMobile: false,
      form: {
        user_id: '',
        name: '',
        phone: '',
        address: ''
      },
      rules: {
        name: [{ required: true, message: 'Please enter name', trigger: 'blur' }],
        phone: [{ required: true, message: 'Please enter phone number', trigger: 'blur' }],
        address: [{ required: true, message: 'Please enter address', trigger: 'blur' }]
      }
    }
  },
  created() {
    // 如果没有勾选购物车商品直接进入确认订单页面,提示信息并返回购物车
    if (this.getCheckNum < 1) {
      this.notifyError('Please check the product before settling')
      this.$router.push({ path: '/cart' })
    }
    this.getAddress()
    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth <= 900
      this._handleResize = () => {
        this.isMobile = window.innerWidth <= 900
      }
      window.addEventListener('resize', this._handleResize)
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined' && this._handleResize) {
      window.removeEventListener('resize', this._handleResize)
    }
  },
  computed: {
    // 结算的商品数量; 结算商品总计; 结算商品信息
    ...mapGetters(['getCheckNum', 'getTotalPrice', 'getCheckGoods'])
  },
  methods: {
    ...mapActions(['deleteShoppingCart']),
    selectAddress(item) {
      this.confirmAddress = item.id
    },
    getAddress() {
      addressesAPI
        .showAddresses(this.$store.getters.getUser.id)
        .then(res => {
          if (res.status === 200) {
            this.address = res.data
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain shipping address', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain shipping address', err)
        })
    },
    addOrder() {
      if (this.confirmAddress === 0) {
        this.notifyError('Please select a shipping address', null)
        return
      }
      let orders = this.getCheckGoods
      for (let i = 0; i < orders.length; i++) {
        var form = {
          user_id: this.$store.getters.getUser.id,
          product_id: orders[i].product_id,
          num: orders[i].num,
          address_id: this.confirmAddress
        }
        ordersAPI
          .postOrder(form)
          .then(res => {
            if (res.status === 200) {
              const temp = orders[i]
              // 删除已经结算的购物车商品
              var form1 = {
                user_id: this.$store.getters.getUser.id,
                product_id: temp.product_id,
                size: temp.size || ''
              }
              cartsAPI
                .deleteCart(form1)
                .then(res => {
                  if (res.status === 200) {
                    // 更新vuex状态
                    this.deleteShoppingCart(temp.product_id, temp.size)
                  } else if (res.status === 20001) {
                    //token过期，需要重新登录
                    this.loginExpired(res.msg)
                  } else {
                    this.notifyError('Shopping cart deletion failed', res.msg)
                  }
                })
                .catch(err => {
                  this.notifyError('Shopping cart deletion failed', err)
                })
              // 跳转我的订单页面
              this.$router.push({ path: '/order' })
              this.notifySucceed('Unpaid orders will be deleted in 15 minutes')
            } else if (res.status === 20001) {
              //token过期，需要重新登录
              this.loginExpired(res.msg)
            } else {
              this.notifyError('Settlement failed', res.msg)
            }
          })
          .catch(err => {
            this.notifyError('Settlement failed', err)
          })
      }
    },
    postEdit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.form.user_id = this.$store.getters.getUser.id
        addressesAPI
          .postAddress(this.form)
          .then(res => {
            if (res.status === 200) {
              this.address = res.data
              this.addVisible = false
              this.notifySucceed('New shipping address successfully created')
            } else if (res.status === 20001) {
              //token过期，需要重新登录
              this.loginExpired(res.msg)
            } else {
              this.notifyError('Failed to create a new shipping address', res.msg)
            }
          })
          .catch(err => {
            this.notifyError('Failed to create a new shipping address', err)
          })
      })
    }
  }
}
</script>
<style scoped>
.confirmOrder {
  background-color: #FBF3EE;
  padding-bottom: 20px;
}
/* 购物车头部CSS */
.confirmOrder .top-header {
  width: 100%;
  background: linear-gradient(135deg, #C49A7A 0%, #9B7058 100%);
  margin-bottom: 30px;
}
.confirmOrder .top-header .cart-header {
  display: flex;
  height: 100px;
  margin: 0 auto;
  width: 1225px;
  position: relative;
  align-items: center;
}
.confirmOrder .top-header .cart-header .logo {
  height: 60px;
  width: 100px;
  margin-right: 24px;
}
.confirmOrder .top-header .cart-header .logo img {
  height: 60px;
}

.confirmOrder .top-header .cart-header p {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
}

.confirmOrder .top-header .cart-header .cart-header-right {
  display: flex;
  position: absolute;
  right: 0px;
}

.confirmOrder .top-header .cart-header .cart-header-select {
  margin-top: 0;
}

.confirmOrder .top-header .cart-header .cart-header-select .href {
  font-size: 13px;
  color: rgba(255,255,255,0.9);
}
.confirmOrder .top-header .cart-header .cart-header-select .href:hover {
  color: #ffffff;
}
.dropdown-menu:hover {
  color: #C49A7A;
  background-color: #FBF3EE;
}
.confirmOrder .top-header .cart-header .cart-header-order {
  margin-top: 0;
}
.confirmOrder .top-header .cart-header .cart-header-order span {
  color: rgba(255,255,255,0.5);
  margin-left: 20px;
  margin-right: 20px;
}
.confirmOrder .top-header .cart-header .cart-header-order .href {
  font-size: 13px;
  color: rgba(255,255,255,0.9);
}
.confirmOrder .top-header .cart-header .cart-header-order .href:hover {
  color: #ffffff;
}

/* 购物车头部CSS END */

/* 主要内容容器CSS */
.confirmOrder .confirm-content {
  width: 1225px;
  margin: 0 auto;
  padding: 40px 0 0;
  background-color: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 18px 40px rgba(196, 154, 122, 0.08);
}

/* 选择地址CSS */
.confirmOrder .confirm-content .section-address {
  margin: 0 40px;
  padding: 32px 0;
  border-bottom: 1px solid #E8D8D0;
  overflow: hidden;
}
.confirmOrder .confirm-content .section-address .title {
  color: #2D2D2D;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.confirmOrder .confirm-content .address-body {
  overflow: hidden;
}
.confirmOrder .confirm-content .address-body ul {
  overflow: hidden;
}
.confirmOrder .confirm-content .address-body li {
  float: left;
  color: #333;
  width: 220px;
  min-height: 150px;
  border: 2px solid #E8D8D0;
  border-radius: 12px;
  padding: 20px;
  margin-right: 16px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s;
  box-sizing: border-box;
}
.confirmOrder .confirm-content .address-body li:hover {
  border-color: #818CF8;
}
.confirmOrder .confirm-content .address-body .in-section {
  border: 2px solid #C49A7A;
  background: rgba(196, 154, 122, 0.03);
}
.confirmOrder .confirm-content .address-body li h2 {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 8px;
  color: #2D2D2D;
}
.confirmOrder .confirm-content .address-body li p {
  font-size: 13px;
  color: #666666;
  line-height: 1.5;
}
.confirmOrder .confirm-content .address-body li .phone {
  margin-bottom: 8px;
}
.confirmOrder .confirm-content .address-body li .address {
  padding: 0;
  max-width: 100%;
  max-height: none;
  line-height: 1.5;
  word-break: break-word;
}
.confirmOrder .confirm-content .address-body .add-address {
  text-align: center;
  line-height: 24px;
  border-style: dashed;
}
.confirmOrder .confirm-content .address-body .add-address:hover {
  border-color: #C49A7A;
  color: #C49A7A;
}
.confirmOrder .confirm-content .address-body .add-address i {
  font-size: 28px;
  padding-top: 30px;
  text-align: center;
  display: block;
}
.confirmOrder .confirm-content .address-body .add-address p {
  color: #666666;
  font-weight: 600;
}
/* 选择地址CSS END */

/* 商品及优惠券CSS */
.confirmOrder .confirm-content .section-goods {
  margin: 0 40px;
  padding: 32px 0;
  border-bottom: 1px solid #E8D8D0;
  overflow: hidden;
}
.confirmOrder .confirm-content .section-goods .title {
  color: #2D2D2D;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 20px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.confirmOrder .confirm-content .section-goods .goods-list {
  padding: 0;
  border: 1px solid #E8D8D0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
.confirmOrder .confirm-content .section-goods .goods-list ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: block;
}
.confirmOrder .confirm-content .section-goods .goods-list li {
  padding: 16px 20px;
  color: #424242;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  border-bottom: 1px solid #E8D8D0;
  background: #fff;
}
.confirmOrder .confirm-content .section-goods .goods-list li:last-child {
  border-bottom: none;
}
.confirmOrder .confirm-content .section-goods .goods-list li img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 16px;
  flex-shrink: 0;
}
.confirmOrder .confirm-content .section-goods .goods-list li .pro-name {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  color: #2D2D2D;
  line-height: 1.4;
  word-break: break-word;
  padding-right: 16px;
}
.confirmOrder .confirm-content .section-goods .goods-list li .pro-price {
  width: 90px;
  text-align: center;
  font-weight: 600;
  color: #2D2D2D;
  flex-shrink: 0;
}
.confirmOrder .confirm-content .section-goods .goods-list li .pro-num {
  width: 50px;
  text-align: center;
  color: #666666;
  flex-shrink: 0;
}
.confirmOrder .confirm-content .section-goods .goods-list li .pro-status {
  width: 0;
  flex-shrink: 0;
}
.confirmOrder .confirm-content .section-goods .goods-list li .pro-total {
  width: 100px;
  text-align: right;
  color: #C49A7A;
  font-weight: 700;
  font-size: 15px;
  flex-shrink: 0;
  padding-right: 8px;
}
/* 商品及优惠券CSS END */

/* 配送方式CSS */
.confirmOrder .confirm-content .section-shipment {
  margin: 0 40px;
  padding: 28px 0;
  border-bottom: 1px solid #E8D8D0;
  display: flex;
  align-items: center;
}
.confirmOrder .confirm-content .section-shipment .title {
  width: 180px;
  color: #2D2D2D;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}
.confirmOrder .confirm-content .section-shipment .shipment {
  flex: 1;
  font-size: 14px;
  color: #666666;
}
/* 自定义单选为主题色 */
.confirmOrder .confirm-content .section-shipment /deep/ .el-radio__label {
  color: #666666;
  font-weight: 600;
}
.confirmOrder .confirm-content .section-shipment /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #C49A7A;
  background: #C49A7A;
}
.confirmOrder .confirm-content .section-shipment /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #C49A7A;
}
/* 配送方式CSS END */

/* 发票CSS */
.confirmOrder .confirm-content .section-invoice {
  margin: 0 40px;
  padding: 28px 0;
  border-bottom: 1px solid #E8D8D0;
  display: flex;
  align-items: center;
}
.confirmOrder .confirm-content .section-invoice .title {
  width: 180px;
  color: #2D2D2D;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}
.confirmOrder .confirm-content .section-invoice .invoice {
  font-size: 14px;
  margin-right: 20px;
  color: #666666;
  font-weight: 500;
}
/* 发票CSS END */

/* 结算列表CSS */
.confirmOrder .confirm-content .section-count {
  margin: 0 40px;
  padding: 28px 0;
  overflow: hidden;
}
.confirmOrder .confirm-content .section-count .money-box {
  float: right;
  text-align: right;
}
.confirmOrder .confirm-content .section-count .money-box .title {
  float: left;
  min-width: 300px;
  height: 30px;
  display: block;
  line-height: 30px;
  color: #666666;
  text-align: right;
}
.confirmOrder .confirm-content .section-count .money-box .value {
  float: left;
  min-width: 100px;
  height: 30px;
  display: block;
  line-height: 30px;
  color: #2D2D2D;
  font-weight: 600;
  text-align: right;
}
.confirmOrder .confirm-content .section-count .money-box .total .title {
  padding-top: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #2D2D2D;
}
.confirmOrder .confirm-content .section-count .money-box .total .value {
  padding-top: 8px;
}
.confirmOrder .confirm-content .section-count .money-box .total-price {
  font-size: 28px;
  font-weight: 700;
  color: #C49A7A;
}
/* 结算列表CSS END */

/* 结算导航CSS */
.confirmOrder .confirm-content .section-bar {
  padding: 24px 40px;
  border-top: 1px solid #E8D8D0;
  overflow: hidden;
}
.confirmOrder .confirm-content .section-bar .btn {
  float: right;
}
.confirmOrder .confirm-content .section-bar .btn .btn-base {
  float: left;
  margin-left: 20px;
  width: 180px;
  height: 48px;
  border: none;
  font-size: 15px;
  font-weight: 700;
  line-height: 48px;
  text-align: center;
  border-radius: 30px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s;
}
.confirmOrder .confirm-content .section-bar .btn .btn-return {
  color: #666666;
  border: 2px solid #E8D8D0;
  background: transparent;
}
.confirmOrder .confirm-content .section-bar .btn .btn-return:hover {
  border-color: #C49A7A;
  color: #C49A7A;
}
.confirmOrder .confirm-content .section-bar .btn .btn-primary {
  background: linear-gradient(135deg, #C49A7A 0%, #9B7058 100%);
  color: #fff;
  box-shadow: 0 4px 16px rgba(196, 154, 122,0.3);
}
.confirmOrder .confirm-content .section-bar .btn .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(196, 154, 122, 0.4);
}
/* 结算导航CSS */

/* 主要内容容器CSS END */

/* 手机端适配 */
@media (max-width: 900px) {
  /* 新建地址弹窗：适配小屏 */
  /deep/ .el-dialog {
    margin: 8vh auto 0 !important;
  }
  /deep/ .el-dialog__body {
    padding: 10px 12px;
  }
  /deep/ .el-form-item {
    margin-bottom: 12px;
  }
  /deep/ .el-textarea__inner {
    min-height: 120px;
  }
  /* 顶部头部 */
  .confirmOrder .top-header .cart-header {
    width: 100%;
    height: auto;
    padding: 12px;
    flex-wrap: wrap;
  }
  .confirmOrder .top-header .cart-header .logo {
    margin-top: 0;
    width: 80px;
    height: 46px;
  }
  .confirmOrder .top-header .cart-header .logo img {
    height: 46px;
  }
  .confirmOrder .top-header .cart-header p {
    margin-top: 0;
    line-height: 46px;
    font-size: 20px;
  }
  .confirmOrder .top-header .cart-header .cart-header-right {
    display: none;
  }

  /* 主体容器 */
  .confirmOrder .confirm-content {
    width: 100%;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
  }

  /* 地址列表：改为两列/一列自适应 */
  .confirmOrder .confirm-content .section-address {
    margin: 0 12px;
    padding: 20px 0;
  }
  .confirmOrder .confirm-content .section-address .title {
    margin-bottom: 12px;
    font-size: 16px;
  }
  .confirmOrder .confirm-content .address-body ul {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .confirmOrder .confirm-content .address-body li {
    float: none;
    width: auto;
    height: auto;
    margin: 0;
    padding: 12px;
    border-radius: 10px;
  }
  .confirmOrder .confirm-content .address-body li .address {
    max-width: 100%;
    max-height: none;
  }
  .confirmOrder .confirm-content .address-body .add-address i {
    padding-top: 10px;
  }
  @media (max-width: 480px) {
    .confirmOrder .confirm-content .address-body ul {
      grid-template-columns: 1fr;
    }
  }

  /* 商品列表：栅格化，避免超出 */
  .confirmOrder .confirm-content .section-goods {
    margin: 0 12px;
    padding: 20px 0;
  }
  .confirmOrder .confirm-content .section-goods .title {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 12px;
  }
  .confirmOrder .confirm-content .section-goods .goods-list {
    padding: 0;
    border-radius: 10px;
  }
  .confirmOrder .confirm-content .section-goods .goods-list li {
    display: flex;
    flex-wrap: wrap;
    padding: 12px;
    gap: 12px;
  }
  .confirmOrder .confirm-content .section-goods .goods-list li img {
    width: 50px;
    height: 50px;
    margin: 0;
    border-radius: 6px;
  }
  .confirmOrder .confirm-content .section-goods .goods-list li .pro-name {
    flex: 1;
    min-width: calc(100% - 62px);
    line-height: 1.4;
    font-size: 13px;
  }
  .confirmOrder .confirm-content .section-goods .goods-list li .pro-price,
  .confirmOrder .confirm-content .section-goods .goods-list li .pro-num,
  .confirmOrder .confirm-content .section-goods .goods-list li .pro-status,
  .confirmOrder .confirm-content .section-goods .goods-list li .pro-total {
    float: none;
    width: auto;
    line-height: 1.4;
    text-align: left;
    font-size: 13px;
  }
  .confirmOrder .confirm-content .section-goods .goods-list li .pro-price {
    order: 2;
  }
  .confirmOrder .confirm-content .section-goods .goods-list li .pro-num {
    order: 3;
  }
  .confirmOrder .confirm-content .section-goods .goods-list li .pro-total {
    order: 4;
    color: #C49A7A;
    font-weight: 700;
  }

  /* 配送/发票：纵向排版 */
  .confirmOrder .confirm-content .section-shipment,
  .confirmOrder .confirm-content .section-invoice {
    margin: 0 12px;
    padding: 16px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .confirmOrder .confirm-content .section-shipment .title,
  .confirmOrder .confirm-content .section-invoice .title {
    float: none;
    width: auto;
    line-height: 28px;
    margin-bottom: 0;
  }
  .confirmOrder .confirm-content .section-shipment .shipment {
    padding-left: 0;
  }

  /* 结算列表：全宽、左对齐 */
  .confirmOrder .confirm-content .section-count {
    margin: 0 12px;
    padding: 12px 0;
  }
  .confirmOrder .confirm-content .section-count .money-box {
    float: none;
    text-align: left;
  }
  .confirmOrder .confirm-content .section-count .money-box .title,
  .confirmOrder .confirm-content .section-count .money-box .value {
    float: none;
    min-width: 0;
    display: inline-block;
  }
  .confirmOrder .confirm-content .section-count .money-box .total .title,
  .confirmOrder .confirm-content .section-count .money-box .total .value {
    padding-top: 6px;
  }

  /* 操作条：按钮全宽堆叠 */
  .confirmOrder .confirm-content .section-bar {
    padding: 12px;
  }
  .confirmOrder .confirm-content .section-bar .btn {
    float: none;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .confirmOrder .confirm-content .section-bar .btn .btn-base {
    width: 100%;
    margin-left: 0;
  }
}
</style>
